import { handleActions } from 'redux-actions'
import * as c from './constants'

const init = {
  init: false,
  loading: false,
  error: null,
  features: {}
}

export default handleActions({
  [c.FEATURES_LOADING]: (state) => ({
    ...state,
    loading: true
  }),
  [c.FEATURES]: (state, { error, payload }) => ({
    init: true,
    loading: false,
    error: error ? payload : null,
    features: error ? {} : payload.data
  })
}, init)
